const env = 'local';
const apiUrl = 'https://laravel-api.parquesnacionales.gov.co';

export const environment = {
  env,
  apiUrl: 'https://dev-api.mitorneo.app',

  // Configuracion de la libreria "home"
  homeConfig: {
    env,
    apiUrl: 'https://dev-api.mitorneo.app',
    apiKey: 'DEV_API_KEY_123',
    enableDebugMode: true,
  },

  // Configuracion de la libreria "tournaments"
  tournamentsConfig: {
    env,
    apiUrl: 'https://dev-api.mitorneo.app',
    bucketUrl: 'https://storage.googleapis.com/mitorneo-local',
    apiKey: 'DEV_API_KEY_123',
    enableDebugMode: true,
  },
};
